/**
 * The page around an embedded HubSpot form.
 *
 * Both form pages are this component with different words. Written once, and
 * called twice, because "both forms should look the same" is a promise a shared
 * layout keeps and two parallel files only make: the moment they are two files,
 * a width tweaked on one page is a difference on the other.
 *
 * What this page can and cannot control is worth stating, because it is not
 * obvious and it was learned the hard way. The embed renders the form inside an
 * iframe and sizes its own height from within. So the form's width is this
 * container's width - that is the scaling lever, and the only one - while the
 * field heights, the type scale and the submit button's colour live in another
 * document and are HubSpot's.
 */
import { HubspotForm } from "../components/HubspotForm";
import { Icon } from "../components/primitives";

export interface AsideItem {
  icon: string;
  text: string;
}

export function FormPage({
  title,
  caption,
  formId,
  asideTitle,
  aside,
}: {
  title: string;
  caption: string;
  formId: string;
  asideTitle: string;
  aside: AsideItem[];
}) {
  return (
    <section className="screen">
      {/*
        The same header every screen has - title left, caption under it - so that
        moving between Documents, the assistant and these pages does not shift
        the title. The header and the body now carry identical horizontal
        padding, which is what puts the title and the form's left edge on one
        line without either of them knowing about the other.
      */}
      <div className="screen__head" style={{ display: "block" }}>
        <h1 className="screen__title" style={{ marginBottom: 4 }}>
          {title}
        </h1>
        <div className="screen__caption">{caption}</div>
      </div>

      <div className="screen__body screen__body--scroll">
        <div className="prose prose--wide">
          <div className="contact">
            <HubspotForm formId={formId} title={title} />
            <aside className="contact__aside">
              <div className="eyebrow">{asideTitle}</div>
              <ul className="contact__list">
                {aside.map((item) => (
                  <li key={item.text}>
                    <Icon name={item.icon} size={18} className="u-muted" />
                    <span>{item.text}</span>
                  </li>
                ))}
              </ul>
            </aside>
          </div>
        </div>
      </div>
    </section>
  );
}
